import { useEffect, useMemo } from 'react';
import { registerIcons, STATION_ICON, STATION_ICON_SELECTED, STATION_SIGN_SIZE } from './icons';
import { fc, GeoJsonLayer } from './layers';
import { useMap } from './map-view';

interface StationLike {
  _id: string;
  name: string;
  geometry: { coordinates: number[] };
}

/** Stations as bus stop signs (from zoom 12); the selected one is larger and yellow. */
export function StationsLayer({
  stations,
  selected,
  onSelect,
  minzoom = 12,
  dim,
}: {
  stations: StationLike[];
  selected?: string | null;
  onSelect?: (id: string) => void;
  minzoom?: number;
  dim?: number;
}) {
  const map = useMap();
  useEffect(() => {
    if (map) registerIcons(map);
  }, [map]);
  const data = useMemo(
    () =>
      fc(
        stations.map((s) => ({
          type: 'Feature' as const,
          geometry: { type: 'Point' as const, coordinates: s.geometry.coordinates },
          properties: { id: s._id, name: s.name, selected: s._id === selected },
        })),
      ),
    [stations, selected],
  );
  return (
    <GeoJsonLayer
      data={data}
      dim={dim}
      onClick={onSelect ? (p) => onSelect(String(p.id)) : undefined}
      layers={[
        {
          type: 'symbol',
          minzoom,
          layout: {
            'icon-image': ['case', ['get', 'selected'], STATION_ICON_SELECTED, STATION_ICON],
            'icon-size': STATION_SIGN_SIZE,
            'icon-allow-overlap': true,
            'symbol-sort-key': ['case', ['get', 'selected'], 1, 0],
          },
        },
      ]}
    />
  );
}
